module.exports = __webpack_public_path__ + "img/56.689c208e.png";